// Stimulus entrypoint for Vite
// Uses stimulus-vite-helpers for cleaner controller registration

import { Application } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"
import { registerControllers } from "stimulus-vite-helpers"
import { I18n } from "i18n-js"

// Disable Turbo Drive to avoid conflicts with jquery-ujs
Turbo.session.drive = false

// Start Stimulus application
const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

// Auto-register all controllers from app/frontend/controllers
// This uses Vite's glob import + stimulus-vite-helpers for automatic discovery
const controllers = import.meta.glob('../controllers/v2/**/*_controller.js', { eager: true })
registerControllers(application, controllers, '../controllers/v2')

// Manual registration with proper name extraction
Object.entries(controllers).forEach(([path, module]) => {
  // Extract controller name from path
  // e.g., '../controllers/v2/context_controller.js' -> 'context'
  const name = path
    .match(/\/([^/]+)_controller\.js$/)?.[1]
    ?.replace(/\//g, '--') // nested dirs
    ?.replace(/_/g, '-') // Handle nested paths with --

  if (name && module.default) {
    application.register(name, module.default)
    console.log(`Registered controller: ${name}`)
  }
})

export { application }
